import React from 'react';
import { Route } from 'react-router-dom';
import StaticPage from '../StaticPage/StaticPage';

const StaticRoute = ({ page, ...rest }) => (
  <Route {...rest} render={props => <StaticPage {...props} page={page} />} />
);

export default StaticRoute;
